<button class="btn btn-primary backToGrid mb-2" type="button" (click)="backToGrid()">
  <i class="mdi mdi-keyboard-return mr-1"></i>
  <span>Back to grid</span>
</button>

<div *ngIf="loading" class="dataLoader"></div>

<div *ngIf="!loading && !bean">
  <div class="alert alert-danger col-12 text-center" name="alert" role="alert">
    <i class="fa fa-search fa-2x"></i>
    <div>{{genericVisuals.nodata}}</div>
  </div>
</div>

<form *ngIf="!loading" class="card form-horizontal" [formGroup]="editForm" autocomplete="off">
  <div class="card-block">
    <h4 class="text-center">
      {{getSelectedActionVisual()}}
    </h4>
    <aw-wizard #wizard [navBarLayout]="'large-empty-symbols'">
      <aw-wizard-step [stepTitle]="'Policy'" class="col-md-7 mx-auto">
        <ng-template awWizardStepSymbol
          ><i class="mdi mdi-arrow-decision mdi-24px"></i
        ></ng-template>

        <div class="dynamic-form-field--select form-group row">
          <label
            class="dynamic-form-field__label--async-select form-control-label mb-0 align-self-center col-md-3 text-md-right input-required"
            for="flowPolicy"
            >Policy</label
          >
          <div class="dynamic-form-field__field-container--async-select col-md-9">
            <ng-select
              class="dynamic-form-field__field--select"
              (change)="setValueSelected('flowPolicy', $event)"
              bindLabel="text"
              bindValue="id"
              formControlName="flowPolicy"
              [clearable]="false"
              [items]="lookups.policyList"
            ></ng-select>
          </div>
        </div>

        <div
          class="dynamic-form-field--input form-group row"
          [hidden]="editForm.value['flowPolicy'] == 'TIERING'"
        >
          <label
            for="authCount"
            class="dynamic-form-field__label--input form-control-label mb-0 align-self-center col-md-3 text-md-right input-required"
            >Authorization count</label
          >
          <div class="dynamic-form-field__field-container--input col-md-9">
            <input
              class="dynamic-form-field__field--input form-control"
              type="number"
              min="{{minAuthCount}}"
              max="10"
              onkeypress="return event.charCode >= 48"
              step="1"
              formControlName="authCount"
              (blur)="authPolicyCountUpdate()"
              required
            />
          </div>
          <div
            *ngIf="formErrors && formErrors['authCount'] != ''"
            class="dynamic-form-field__validation--input offset-md-3 col-md-9 col-sm-12"
          >
            <p
              class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
              role="alert"
            >
              {{formErrors['authCount']}}
            </p>
          </div>
          <div
            *ngIf="minAuthCountExceeded()"
            class="dynamic-form-field__validation--input offset-md-3 col-md-9 col-sm-12"
          >
            <p
              class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
              role="alert"
            >
              Minimum allowed value exceeded
            </p>
          </div>
        </div>

        <div class="dynamic-form-field--input form-group row">
          <label
            for="username"
            class="dynamic-form-field__label--input form-control-label mb-0 align-self-center col-md-3 text-md-right"
            >User of last change</label
          >
          <div class="dynamic-form-field__field-container--input col-md-9">
            <input
              class="dynamic-form-field__field--input form-control"
              type="text"
              formControlName="username"
              readonly="true"
            />
          </div>
        </div>

        <div class="dynamic-form-field--input form-group row">
          <label
            for="timestamp"
            class="dynamic-form-field__label--input form-control-label mb-0 align-self-center col-md-3 text-md-right"
            >Time of last change</label
          >
          <div class="dynamic-form-field__field-container--input col-md-9">
            <input
              class="dynamic-form-field__field--input form-control"
              type="text"
              value="{{editForm.controls['timestamp'].value | date:'dd/MM/yyyy, HH:mm:ss'}}"
              readonly="true"
            />
          </div>
        </div>

        <div class="text-center">
          <button
            awNextStep
            class="btn btn-default"
            type="button"
            [disabled]="loading || submiting || !editForm.controls['authCount'].valid || minAuthCountExceeded()"
          >
            <i class="mdi mdi-arrow-right"></i>
            <span class="">Next</span>
          </button>
        </div>
      </aw-wizard-step>
      <aw-wizard-step [stepTitle]="'Workflow'">
        <ng-template awWizardStepSymbol
          ><i class="mdi mdi-account-settings mdi-24px"></i
        ></ng-template>
        <div formGroupName="policyConfig">
          <div [ngSwitch]="editForm.value['flowPolicy']">
            <div *ngSwitchCase="'SEQUENTIAL'" formArrayName="sequence" class="col-md-6 mx-auto">
              <h5 class="centered-content mb-2">Approval Sequence</h5>
              <div
                *ngFor="let item of editForm.controls['policyConfig'].controls['sequence'].controls; let i = index; let last = last"
                [formGroupName]="i"
                class="dynamic-form-field--select form-group row"
              >
                <label
                  *ngIf="!last"
                  class="dynamic-form-field__label--async-select form-control-label mb-0 align-self-center col-md-3 text-md-right input-required"
                  for="rprId"
                  >#{{i+1}} Verifier</label
                >
                <label
                  *ngIf="last"
                  class="dynamic-form-field__label--async-select form-control-label mb-0 align-self-center col-md-3 text-md-right input-required"
                  for="rprId"
                  >Approver</label
                >

                <div class="dynamic-form-field__field-container--async-select col-md-9">
                  <ng-select
                    *ngIf="!last"
                    class="dynamic-form-field__field--select"
                    (change)="setValueSelected('rprId', $event)"
                    bindLabel="text"
                    bindValue="id"
                    formControlName="rprId"
                    [clearable]="false"
                    [items]="lookups.verifierList | async"
                  ></ng-select>

                  <ng-select
                    *ngIf="last"
                    class="dynamic-form-field__field--select"
                    (change)="setValueSelected('rprId', $event)"
                    bindLabel="text"
                    bindValue="id"
                    formControlName="rprId"
                    [clearable]="false"
                    [items]="lookups.approverList | async"
                  ></ng-select>

                  <div
                    *ngIf="item.value.rprId == null"
                    class="dynamic-form-field__validation--input"
                  >
                    <p
                      class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
                      role="alert"
                    >
                      {{genericVisuals.required}}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div *ngSwitchCase="'TIERING'">
               <div
                *ngIf="editForm.value['actionCd'].includes('REC_FILE')"
                class="dynamic-form-field--input mb-2"
              >
                <div><h5>Based On</h5></div>
                <div
                  class=""
                >
                  <input
                    type="radio"
                    id="max"
                    name="basedOn"
                    value="max"
                    class="custom-control-input"
                    formControlName="basedOn"
                  />
                  <label class="custom-control-label" for="max">MAX Invoice Amount</label>
                </div>
                <div
                  class=""
                >
                  <input
                    type="radio"
                    id="sum"
                    name="basedOn"
                    value="sum"
                    class="custom-control-input"
                    formControlName="basedOn"
                  />
                  <label class="custom-control-label" for="sum">SUM of Invoice Amount</label>
                </div>
              </div>
              <h5>Workflow Groups</h5>
              <div class="row" formArrayName="groups">
                <div class="col-12">
                  <div class="table-responsive">
                    <table
                      class="dynamic-grid__table table table-striped table-hover table-sm condensed"
                    >
                      <thead class="dynamic-grid__table-header">
                        <tr class="dynamic-grid__table-header-row text-brand-primary-1">
                          <th class="dynamic-grid__table-header-col"></th>
                          <th class="dynamic-grid__table-header-col">#</th>
                          <th class="dynamic-grid__table-header-col">Group Visual</th>
                          <th class="dynamic-grid__table-header-col">Members</th>
                        </tr>
                      </thead>
                      <tbody class="dynamic-grid__table-body">
                        <tr
                          *ngFor="let item of editForm.controls['policyConfig'].controls['groups'].controls; let i = index; let last = last"
                          [formGroupName]="i"
                          class="dynamic-grid__table-body-row"
                        >
                          <td class="dynamic-grid__table-body-col--count centered-content">
                            <i
                              class="mdi mdi-minus-circle-outline mdi-16px"
                              tooltip="Remove group"
                              (click)="removeGroups(i)"
                            ></i>
                          </td>
                          <td class="dynamic-grid__table-body-col--count">
                            <input
                              class="dynamic-form-field__field--input form-control"
                              type="text"
                              formControlName="groupId"
                              value="{{i+1}}"
                              readonly="true"
                            />
                          </td>
                          <td class="dynamic-grid__table-body-col--count">
                            <input
                              class="dynamic-form-field__field--input form-control"
                              type="text"
                              formControlName="groupVisual"
                              (blur)="calcGroupItems()"
                            />
                            <div
                              *ngIf="!item.value.groupVisual"
                              class="dynamic-form-field__validation--input"
                            >
                              <p
                                class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
                                role="alert"
                              >
                                {{genericVisuals.required}}
                              </p>
                            </div>
                          </td>
                          <td class="dynamic-grid__table-body-col--count">
                            <ng-select
                              class="dynamic-form-field__field--select"
                              (change)="setValueSelected('members', $event)"
                              bindLabel="text"
                              bindValue="id"
                              formControlName="members"
                              [clearable]="false"
                              appendTo="body"
                              [items]="lookups.approverList | async"
                              [multiple]="true"
                            ></ng-select>
                            <div
                              *ngIf="!item.value.members || item.value.members.length == 0"
                              class="dynamic-form-field__validation--input"
                            >
                              <p
                                class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
                                role="alert"
                              >
                                {{genericVisuals.required}}
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="dynamic-grid__table-body-col--count centered-content">
                            <i
                              class="mdi mdi-plus-circle-outline mdi-16px"
                              tooltip="Add group"
                              (click)="addGroups()"
                            ></i>
                          </td>
                          <td class="dynamic-grid__table-body-col--count"></td>
                          <td class="dynamic-grid__table-body-col--count"></td>
                          <td class="dynamic-grid__table-body-col--count"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <h5>Hierarchy</h5>
              <div class="dynamic-form-field--input mb-2">
                <div class="">
                  <input
                    type="radio"
                    id="sequential"
                    name="tierHierarchy"
                    value="sequential"
                    class="custom-control-input"
                    formControlName="tierHierarchy"
                  />
                  <label class="custom-control-label" for="sequential">Sequential</label>
                </div>
                <div class="">
                  <input
                    type="radio"
                    id="nonSequential"
                    name="tierHierarchy"
                    value="nonSequential"
                    class="custom-control-input"
                    formControlName="tierHierarchy"
                  />
                  <label
                    class="custom-control-label"
                    for="nonSequential"
                    >Non Sequential</label
                  >
                </div>
              </div>
              <h5>Workflow Tiers</h5>
              <div class="row" formArrayName="tiers">
                <div class="col-12">
                  <div class="table-responsive">
                    <table
                      class="dynamic-grid__table table table-striped table-hover table-sm condensed"
                    >
                      <thead class="dynamic-grid__table-header">
                        <tr class="dynamic-grid__table-header-row text-brand-primary-1">
                          <th class="dynamic-grid__table-header-col"></th>
                          <th class="dynamic-grid__table-header-col">#</th>
                          <th class="dynamic-grid__table-header-col">Min Amount</th>
                          <th class="dynamic-grid__table-header-col">Max Amount</th>
                          <th class="dynamic-grid__table-header-col">Workflow</th>
                        </tr>
                      </thead>
                      <tbody class="dynamic-grid__table-body">
                        <tr
                          *ngFor="let tierItem of editForm.controls['policyConfig'].controls['tiers'].controls; let i = index;"
                          [formGroupName]="i"
                          class="dynamic-grid__table-body-row"
                        >
                          <td class="dynamic-grid__table-body-col--count centered-content">
                            <i
                              *ngIf="i > 0"
                              class="mdi mdi-minus-circle-outline mdi-16px"
                              tooltip="Remove Tier"
                              (click)="removeTiers(i)"
                            ></i>
                          </td>
                          <td class="dynamic-grid__table-body-col--count">
                            {{i+1}}
                          </td>
                          <td class="dynamic-grid__table-body-col--count">
                            <div *ngIf="i > 0">
                              <input
                                currencyMask
                                [options]="customCurrencyConfig"
                                class="dynamic-form-field__field--currency form-control"
                                (blur)="minAmountChanged(i)"
                                onkeyup="if(this.value<0){this.value= this.value * -1}"
                                formControlName="minAmount"
                                type="tel"
                              />
                              <div
                                *ngIf="!tierItem.value.minAmount"
                                class="dynamic-form-field__validation--input"
                              >
                                <p
                                  class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
                                  role="alert"
                                >
                                  {{genericVisuals.required}}
                                </p>
                              </div>
                            </div>
                            <div *ngIf="i == 0">
                              <input
                                currencyMask
                                [options]="customCurrencyConfig"
                                class="dynamic-form-field__field--currency form-control"
                                formControlName="minAmount"
                                type="tel"
                                disabled
                              />
                            </div>
                          </td>
                          <td class="dynamic-grid__table-body-col--count">
                            <div
                              *ngIf="i != (editForm.controls['policyConfig'].controls['tiers'].controls.length -1)"
                            >
                              <input
                                currencyMask
                                [options]="customCurrencyConfig"
                                class="dynamic-form-field__field--currency form-control"
                                formControlName="maxAmount"
                                (blur)="maxAmountChanged(i)"
                                onkeyup="if(this.value<0){this.value= this.value * -1}"
                                type="tel"
                              />
                              <div
                                *ngIf="!tierItem.value.maxAmount"
                                class="dynamic-form-field__validation--input"
                              >
                                <p
                                  class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
                                  role="alert"
                                >
                                  {{genericVisuals.required}}
                                </p>
                              </div>
                            </div>
                            <div
                              *ngIf="i == (editForm.controls['policyConfig'].controls['tiers'].controls.length -1)"
                            >
                              <input
                                currencyMask
                                [options]="customCurrencyConfig"
                                class="dynamic-form-field__field--currency form-control"
                                formControlName="maxAmount"
                                type="tel"
                                disabled
                              />
                            </div>
                          </td>
                          <td class="dynamic-grid__table-body-col--count" formGroupName="workflow">
                            <div
                              class="row pb-1 m-0"
                              *ngFor="let workflowItem of tierItem.controls['workflow'].controls; let j = index; let len = count; let lst = last;"
                              [formGroupName]="j"
                            >
                              <span class="col-sm-7">
                                <ng-select
                                  class="dynamic-form-field__field--select"
                                  (change)="setValueSelected('wfgroupId', $event)"
                                  bindLabel="controls.groupVisual.value"
                                  bindValue="controls.groupId.value"
                                  formControlName="groupId"
                                  [clearable]="false"
                                  appendTo="body"
                                  [items]="editForm.controls['policyConfig'].controls['groups'].controls"
                                ></ng-select>
                                <div
                                  *ngIf="!workflowItem.value.groupId"
                                  class="dynamic-form-field__validation--input"
                                >
                                  <p
                                    class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
                                    role="alert"
                                  >
                                    {{genericVisuals.required}}
                                  </p>
                                </div>
                              </span>
                             
                              <span class="col-sm-2 centered-content">
                                <input
                                  class="dynamic-form-field__field--input form-control"
                                  type="number"
                                  min="0"
                                  onkeypress="return event.charCode >= 48"
                                  step="1"
                                  formControlName="count"
                                />
                                <div
                                  *ngIf="!workflowItem.value.count"
                                  class="dynamic-form-field__validation--input"
                                >
                                  <p
                                    class="dynamic-form-field__validation-text--input text-danger font-sm mb-0"
                                    role="alert"
                                  >
                                    {{genericVisuals.required}}
                                  </p>
                                </div>
                              </span>
                              <span [style.visibility]="!lst ? 'visible' : 'hidden'" class="col-sm-2">
                                <ng-select
                                  class="dynamic-form-field__field--select"
                                  bindLabel="text"
                                  bindValue="id"
                                  formControlName="rule"
                                  [clearable]="false"
                                  [items]="lookups.logicalConditions"
                                >
                                </ng-select>
                              </span>
                              <span class="col-sm-1 centered-content"
                                ><i
                                  class="mdi mdi-minus-circle-outline mdi-16px"
                                  tooltip="Remove group"
                                  (click)="removeWorkflow(tierItem,j)"
                                ></i
                              ></span>
                            </div>
                            <div class="row p-0 m-0">
                              <span class="col-sm-12 centered-content"
                                ><i
                                  class="mdi mdi-plus-circle-outline mdi-16px"
                                  [ngStyle]="{'color': (editForm.value.policyConfig.tiers[i].workflow.length == 0) ? 'red' : null}"
                                  tooltip="Add group"
                                  (click)="addWorkflow(tierItem)"
                                ></i
                              ></span>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td class="dynamic-grid__table-body-col--count centered-content">
                            <i
                              class="mdi mdi-plus-circle-outline mdi-16px"
                              tooltip="Add Tier"
                              (click)="addTiers()"
                            ></i>
                          </td>
                          <td class="dynamic-grid__table-body-col--count"></td>
                          <td class="dynamic-grid__table-body-col--count"></td>
                          <td class="dynamic-grid__table-body-col--count"></td>
                          <td class="dynamic-grid__table-body-col--count"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div *ngSwitchDefault>
              <h5 class="centered-content my-2">No configuration needed</h5>
            </div>
          </div>

          <div class="text-center">
            <button
              awPreviousStep
              class="btn btn-outline-default"
              type="button"
              [disabled]="loading || submiting"
            >
              <i class="mdi mdi-arrow-left"></i>
              <span class="">Back</span>
            </button>
            <button
              awNextStep
              class="btn btn-default"
              type="button"
              [disabled]="loading || submiting || nextButtonDisabled()"
            >
              <i class="mdi mdi-arrow-right"></i>
              <span class="">Next</span>
            </button>
          </div>
        </div>
      </aw-wizard-step>
      <aw-wizard-step [stepTitle]="'Overview'">
        <ng-template awWizardStepSymbol><i class="mdi mdi-check mdi-24px"></i></ng-template>
        <div class="centered-content col-md-6">
          <p>
            Internal authorization using <b>{{editForm.value.flowPolicy}}</b> policy is selected.
          </p>
          <span [ngSwitch]="editForm.value['flowPolicy']">
            <div *ngSwitchCase="'SEQUENTIAL'">
              After the execution of the specified transaction, an approval sequence will be
              initiated with members and order as configured in the previous step before the said
              transaction is forwarded to the bank for processing.
            </div>

            <div *ngSwitchCase="'TIERING'">
              After the execution of the specified transaction, an approval sequence will be
              initiated with members and workflow as configured in the previous step, based on the
              transaction amount, before the said transaction is forwarded to the bank for
              processing.
            </div>

            <div *ngSwitchDefault>
              <span *ngIf="editForm.value['authCount'] == 0">
                Execution of the specified transaction will be immediatelly forwarded to the bank
                for processing.
              </span>
              <span *ngIf="editForm.value['authCount'] > 0">
                After the execution of the specified transaction, an approval sequence of
                {{editForm.value['authCount']}} steps will be initiated based on your company's role
                setup of Approvers and/or Verifiers, before the said transaction is forwarded to the
                bank for processing.
              </span>
            </div>
          </span>

          <div *ngIf="submiting" class="dataLoader"></div>

          <div *ngIf="submitError" class="text-danger my-3 centered-content">
            <div><i class="mdi mdi-alert-circle-outline mdi-24px"></i></div>
            <div>
              <div>{{submitError}}</div>
              <div>Please retry after adressing the above issue.</div>
            </div>
          </div>

          <div class="text-center mt-2">
            <button
              awPreviousStep
              class="btn btn-outline-default"
              type="button"
              [disabled]="loading || submiting"
            >
              <i class="mdi mdi-arrow-left"></i>
              <span class="">Back</span>
            </button>
            <button
              class="btn btn-default"
              type="button"
              (click)="save(bean)"
              [disabled]="loading || submiting"
            >
              <i class="mdi mdi-check"></i>
              <span class="">Submit</span>
            </button>
          </div>
        </div>
      </aw-wizard-step>
    </aw-wizard>
  </div>
</form>
